<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Dependents</h3>
      </template>
      <div class="row">
        <div class="col-md-12">
          <nav class="row">
            <ol class="breadcrumb arr-right bg-breadcrum">
              <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/hr/employeelist">Active Employees</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/hr/resigned">Inactive Employees</router-link>
              </li>
              <li class="breadcrumb-item active">Dependents</li>
              <li class="breadcrumb-item">
                <router-link to="/hr/workshifts">Workshifts</router-link>
              </li>
              <!-- NEW ADDITIONAL -->
              <li class="breadcrumb-item">
                <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/hr/undertimerequest">Undertime Request</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/hr/nterequest">NTE Tracker</router-link>
              </li>
              <li class="breadcrumb-item">
                  <router-link to="/hr/coaching/records">Employee Coached</router-link>
                </li>
            </ol>
          </nav>
        </div>
        <div class="col-md-12"><hr style="margin-top:-10px"/></div>
        <div class="col-md-6"></div>
        <div class="col-md-6 float-right">
          <router-link to="/hr/dependentform" class="btn btn-primary float-right"><i class="fa fa-plus"></i>&nbsp;Register Dependent</router-link>
        </div>
        <div class="col-md-12"><hr/></div>
      </div>
     
      <div class="row">
        <div class="col-md-10">
          <p><i class="fa fa-search"></i> Search Employee</p>
          <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
        </div>
        <div class="col-md-1">
          <div class="form-group">
            <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
            <select v-model="order_by" class="form-control" required>
              <option value="">Default</option>
              <option value="-1">ASC</option>
              <option value="1">DESC</option>
            </select>
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-group">
            <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
            <select v-model="page_limit" class="form-control" required>
              <option value="">Default</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>
        </div>
      </div>
      <hr>
      <!-- PAGINATION -->
      <b-pagination
        v-model="curentPage"
        :total-rows="dependent_item.length"
        :per-page="perPage"
        aria-controls="my-table"
        align="right"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        ></b-pagination>
      <!-- END PAGINATION -->
      <hr>
      <div class="table-responsive ">
        <table class="table table-striped table-hover " v-loading="loading">
          <thead>
            <tr>
              <th>#</th>
              <th>Employee Name</th>
              <th>Dependents</th>
              <th></th>
              <th><i class="fa fa-blind"></i>Seniors</th>
              <th width="200"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="resp , index in computedEmployee">
              <template v-if="resp === 'no data found'">
                <td colspan="100%">
                  <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                </td>
              </template>
              <template v-else>
                <td>{{index + 1}}.</td>
                <td> {{resp.full_name | capitalize}}</td>
                <td>
                  <div v-for="d in resp.dependents">
                    <b>Name of Dependent</b> : &nbsp;&nbsp;  {{d.name}} <br/>
                    <b>Relationship</b> : &nbsp;&nbsp; {{d.relationship}}<br/><br/>
                  </div>
                </td>
                <td>
                  <div v-for="d in resp.dependents">
                    <b>Age</b> :&nbsp;&nbsp; {{d.age}} <br/>
                    <b>Phic NO</b>: &nbsp;&nbsp;{{d.phic_no}} <br/><br/>
                  </div>
                </td>
                <td>
                  <div v-for="s in resp.seniors">
                    <b>senior_citizen</b>   : {{s.senior_citizen}} <br/>
                    <b>middle_initial</b> : {{s.middle_initial}} <br/><br/>
                  </div>
                </td>
                <td>
                  <router-link :to="{name: 'edit-dependent', params: { id: resp.id }}" v-b-tooltip.hover title="click to view details and modify records" class="btn btn-xs"><i class="fa fa-pencil"></i>Update</router-link>
                  <button  class="btn btn-xs" @click = "deleteItem(resp.id, index)">
                    <li class="fa fa-trash-o"></li>
                    &nbsp;Delete
                  </button>
                </td>
              </template>
            </tr>
          </tbody>
        </table><br/>
        <!-- PAGINATION NATIVE WAY -->
        <div class="row">
          <div class="col-md-6">
            <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
          </div>
          <div class="col-md-6">
            <b-pagination
              v-model="curentPage"
              :total-rows="dependent_item.length"
              :per-page="perPage"
              aria-controls="my-table"
              align="right"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              ></b-pagination>
          </div>
        </div>
        <!-- END PAGINATION -->
        <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
        <center>
           <br/><br/>
           <img  src="/static/img/warning.png"  width="225" height="190">
           <h1>You've lost your network connection</h1>
           <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
           <br/><br/>
        </center>
     </template>
      </div>
    </card>
  </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },

  data() {
    return {
      dependent_item: [],
      loading: true,
      //filter
      filter_by_position: '',
      filter_by_status: '',
      search: '',
      order_by: '',
      page_limit: '',
      start_page: 1,
      sortAsc: true,
      //PAGINATION
      perPage: 20,
      curentPage: 1,
       //Indicator
       display_indicator: '',
    }
  },

  mounted: function () {
    this.get_employees()
  },

  methods: {
    get_employees() {
      axios.get('api/dependents')
        .then(response => {
          this.dependent_item = response.data;
          this.display_indicator = 2;
          this.loading = false
        })
        .catch(e => {
          console.log(e.response)
          this.display_indicator = 1;

        })
    },
    deleteItem(id, index) {

      /* USING SWEET ALERT */

      this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: false,
          showLoaderOnConfirm: true
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.delete('api/dependents/delete/' + id)
              .then(response => {
                this.dependent_item.splice(index, 1); //--> reloader 
                this.$swal('Deleted', 'You successfully deleted this file', 'success')
              })
              .catch(response => {
                //alert("error");
                console.log(response);
                this.$swal('Error Code', 'Review your code', 'error')
              });
          }
        });


    },
  },
  computed: {
    // PAGINATION
    offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit() {
      return this.offset + this.page_limit;
    },
    total_item() {
      return this.dependent_item.length
    },

    computedEmployee() {
      let filtered = this.dependent_item
      // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end)

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }
      }
      return filtered
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-dependents.vue